import { createSubscriptionApi } from '@platform/billing';
import { apiClient } from '@/shared/api/client';

/**
 * 구독·라이선스 호출부. SSOT 는 `@platform/billing` — 이 앱의 apiClient 만 주입한다.
 * 응답 타입은 호출부와 한 파일에 있었으므로 기존 import 경로 유지를 위해 함께 re-export.
 */
export const subscriptionApi = createSubscriptionApi(apiClient);

export type {
  AnnualTerminationPreview,
  EarlyTerminationPreview,
  SeatImpactPreview,
  ReactivationPreview,
  WithdrawalIneligibleReason,
  WithdrawalPreview,
  WithdrawalResult,
} from '@platform/billing';
